export default {
  title: 'Cumulez des points & obtenez des récompenses',
  header: {
    pickup: 'À emporter en 5 minutes',
  },
  recommendations: {
    title: 'Recommandé',
  },
  discounts: {
    title: 'Réductions',
    data: [
      {
        title: '+125 points bonus',
        description: 'Notez-nous sur Google',
      },
      {
        title: '+{{amount}} de réduction',
        description: '+{{amount}} de réduction en payant avec le code {{code}}',
      },
    ],
    button: {
      add: '+ Ajouter',
    },
  },
  rewards: {
    title: 'Récompenses & coupons',
    balance: 'Solde',
    points: 'Points',
  },
};
